export enum Brand {
    MERCEDES = 'MERCEDES',
    BMW = 'BMW'
}

export const BrandDescriptions: Record<Brand, string> = {
    [Brand.MERCEDES]: 'Mercedes-Benz',
    [Brand.BMW]: 'Bayerische Motoren Werke (BMW)'
};
